// import queries
import { queries } from 'RestAPIs/rapini';

// import components
import TableCRUDLayout from 'components/shared/CRUD/TableCRUDLayout';
import { useGetColumns } from './hooks/useGetColumns';
import { useState } from 'react';
import { EndOfEmploymentSettlementsDrawer } from './components/EndOfEmploymentSettlementsDrawer';
import { useTranslation } from 'react-i18next';
import { EndOfEmploymentSettlementResponse } from 'generated/index';
import NewFeatureInformationDialog from 'components/shared/NewFeatureInformationDialog/NewFeatureInformationDialog';

const EndOfEmploymentSettlements = () => {
  const { data, isLoading } = queries.useGetEndOfEmploymentSettlementOverview();
  const showPlusMinusHoursReversed =
    data?.some(
      (item) =>
        item.hourManagementPresentationMode ===
        'SHOW_MORE_HOURS_WITH_PLUS_SIGN_AND_MINUS_HOURS_WITH_MINUS_SIGN'
    ) ?? false;

  const columns = useGetColumns(showPlusMinusHoursReversed);

  const [selectedRow, setSelectedRow] =
    useState<EndOfEmploymentSettlementResponse>();
  const { t } = useTranslation('common', {
    keyPrefix: 'endOfEmploymentSettlement'
  });

  const [openDrawer, setOpenDrawer] = useState<boolean>(false);

  const handleOpenDrawer = (id: number | string, selectedRow) => {
    setSelectedRow(selectedRow);
    setOpenDrawer(true);
  };

  const handleCloseDrawer = () => {
    setOpenDrawer(false);
  };

  return (
    <>
      <TableCRUDLayout
        rows={data ?? []}
        columns={columns}
        loading={isLoading}
        getRowId={(row) => row.employment.id}
        editable={false}
        initialState={{
          sorting: {
            sortModel: [{ field: 'name', sort: 'asc' }]
          }
        }}
        customActions={[
          {
            onClick: handleOpenDrawer,
            icon: 'money-check-pen',
            tooltipTitle: t('settlement')
          }
        ]}
        hideCreateAction
      />
      {selectedRow && (
        <EndOfEmploymentSettlementsDrawer
          open={openDrawer}
          selectedRow={selectedRow}
          onClose={handleCloseDrawer}
          showPlusMinusHoursReversed={showPlusMinusHoursReversed}
        />
      )}

      <NewFeatureInformationDialog
        title={t('newFeatureInformationDialog.title')}
        tooltipTitle={t('newFeatureInformationDialog.tooltipTitle')}
        speechBubbleText={t('newFeatureInformationDialog.speechBubbleText')}
        uniqueFeatureName="featureID-EndOfEmploymentSettlements"
        content={t('newFeatureInformationDialog.content')}
        showCoverImage={true}
        coverImageUrl={
          'aysist/styles/external/img/end-of-employment-settlements-info-cover.jpg'
        }
      />
    </>
  );
};

export default EndOfEmploymentSettlements;
